import PropTypes from 'prop-types'
import { Spin, Flex } from 'antd'
import { useIntl } from 'react-intl'

const LoadingSpinnerOverlay = ({ active, text, children }) => {
  const intl = useIntl()
  const displayText = text || intl.formatMessage({id: 'processes.loading'})
  if (!active) {
    return children || null
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.4)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Flex vertical align="center" gap={16}>
        <Spin size="large" />

        <div
          style={{
            color: '#fff',
            fontSize: 16,
            fontWeight: 500,
          }}
        >
          {displayText}
        </div>

        {children}
      </Flex>
    </div>
  )
}

LoadingSpinnerOverlay.propTypes = {
  active: PropTypes.bool.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
}

export default LoadingSpinnerOverlay
